import axios from "axios";
import { STRIPE_PENDING_CHECKOUT_KEY } from "../constants/stripeCheckout";

export const STRIPE_PENDING_CHECKOUT_LOCAL_KEY = "vaStripePendingCheckoutLocal";

export function paymentIntentIdFromClientSecret(clientSecret) {
  if (!clientSecret || typeof clientSecret !== "string") return "";
  const marker = "_secret_";
  const idx = clientSecret.indexOf(marker);
  return idx > 0 ? clientSecret.slice(0, idx) : "";
}

export function saveStripePendingCheckout(data) {
  const payload = JSON.stringify({ ...data, savedAt: Date.now() });
  sessionStorage.setItem(STRIPE_PENDING_CHECKOUT_KEY, payload);
  try {
    localStorage.setItem(STRIPE_PENDING_CHECKOUT_LOCAL_KEY, payload);
  } catch {
    /* private mode / quota */
  }
}

export function loadStripePendingCheckout() {
  try {
    const fromSession = sessionStorage.getItem(STRIPE_PENDING_CHECKOUT_KEY);
    if (fromSession) return JSON.parse(fromSession);
  } catch {
    /* ignore */
  }
  try {
    const fromLocal = localStorage.getItem(STRIPE_PENDING_CHECKOUT_LOCAL_KEY);
    if (fromLocal) return JSON.parse(fromLocal);
  } catch {
    /* ignore */
  }
  return null;
}

export function clearStripePendingCheckout() {
  sessionStorage.removeItem(STRIPE_PENDING_CHECKOUT_KEY);
  try {
    localStorage.removeItem(STRIPE_PENDING_CHECKOUT_LOCAL_KEY);
  } catch {
    /* ignore */
  }
}

export async function registerStripePendingCheckout({
  server,
  paymentIntentId,
  order,
  orderData,
  walletAmountUsed = 0,
}) {
  if (!paymentIntentId || !order) return;
  await axios.post(
    `${server}/order/register-stripe-pending-checkout`,
    {
      paymentIntentId,
      orderPayload: order,
      orderDataExtras: orderData || null,
      walletAmountUsed: Number(walletAmountUsed || 0),
    },
    { withCredentials: true }
  );
}
